import { formatMesAno } from "../../utils/Formatter";

export function get(fetch, filtros) {
  return fetch().post("/dados", { ...filtros, mesAno: formatMesAno(filtros.mesAno) });
}
